import type { FaireProductEntity } from "../../entity_types/product";

export const p_3juzum5n7q: FaireProductEntity = {
  token: "p_3juzum5n7q",
  type: "product",
  name: 'All Purpose Apron with Pocket-31"L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/14cbf0aa349a7a8904a73a83c8a5129cec68fa61e6ed9858eebefa253619e1a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8806cadb89a76739959e57207639882736ab6fb72831ee5de614db15d83f3701.jpeg",
    "https://cdn.faire.com/fastly/8bc4c67373585570d99940ea61881b357b7a5b61a5c8528567864c70b21bd879.jpeg",
    "https://cdn.faire.com/fastly/f652a6d91e0ba3b8c5758483c0c543ee70788ebeb4a63e2b9d8da51f9f5752f3.jpeg",
    "https://cdn.faire.com/fastly/04ca2732c055cbd515965ac9afbe43e53d7cae8ef883ec706841cd67609938f0.jpeg",
    "https://cdn.faire.com/fastly/b268e12faf0c9ff06121ae11437d6917d741ed7c439e851a712eb8a57d0e39dd.jpeg",
    "https://cdn.faire.com/fastly/5c86bf5bf856ffc1f94a59f24f966f9490228c7cebd4f08c6050ff723364beee.jpeg",
    "https://cdn.faire.com/fastly/c8b4fd40e339b514348cf28d87437fa46be3b94d10e8d44008e9f3f7f66818ee.jpeg",
    "https://cdn.faire.com/fastly/d4880ad831c52d2e19ed0c8038a0e78a55c763d3d3ed9c6579f31163fc69b433.jpeg",
    "https://cdn.faire.com/fastly/2e761dd33494c82fee40d63c1d78560810011552cd554fc762186e0d14237548.jpeg",
    "https://cdn.faire.com/fastly/208b16e3c9186bee10e5c0ebc67a303dbbe290444607b61dda3c447d11002ea5.jpeg",
    "https://cdn.faire.com/fastly/a70f6d45b05780c3b771086189c3b7361937a5e25453529217ab77cb15eccb75.jpeg",
    "https://cdn.faire.com/fastly/aee41b6f86621253c65266f3774f89da8d7288f49d86135938d2533493071179.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Made from sturdy cotton canvas in a subtle tones, this apron is designed for both kitchen and creative work. Features include an adjustable neck strap, long waist ties, and a spacious front pocket for tools or utensils.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:17.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
